import { c as _c } from "react/compiler-runtime";
import { Divider } from '@onefootprint/ui';
import type React from 'react';
import { useEffect, useRef, useState } from 'react';
type LineItemProps = {
  label: string;
  value?: string;
  badge?: React.ReactNode;
  customValue?: React.ReactNode;
};
const LineItem = t0 => {
  const $ = _c(16);
  const {
    label,
    value,
    badge,
    customValue
  } = t0;
  const [isValueTruncated, setIsValueTruncated] = useState(false);
  const valueRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== value) {
    t1 = () => {
      const valueElement = valueRef.current;
      if (valueElement && value) {
        setIsValueTruncated(valueElement.offsetWidth < valueElement.scrollWidth);
      }
    };
    t2 = [value];
    $[0] = value;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== label) {
    t3 = <p className="text-body-2 text-primary">{label}</p>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== badge || $[6] !== t3) {
    t4 = <div className="flex items-center gap-2 min-w-fit max-w-[30%]">{t3}{badge}</div>;
    $[5] = badge;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Divider variant="secondary" className="mb-1" />;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== customValue || $[10] !== isValueTruncated || $[11] !== value) {
    t6 = customValue ?? <div className="flex items-center gap-1 justify-end max-w-[50%]"><p ref={valueRef} className="text-body-2 text-primary truncate" title={isValueTruncated ? value : undefined}>{value}</p></div>;
    $[9] = customValue;
    $[10] = isValueTruncated;
    $[11] = value;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div className="flex items-end gap-2 w-full">{t4}{t5}{t6}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
};
export default LineItem;